import { Markdown } from "@/components/CodeGen";
import type { FpFile } from "../../../../schemas/codegen";
import { TextFileSkeleton } from "./TextFileSkeleton";

interface MarkdownAttachmentViewProps {
  attachment: FpFile;
}

const syntaxHighlighterOptions = {
  className: "rounded-md px-0 py-4 bg-muted",
  showLineNumbers: false,
};

export function MarkdownAttachmentView({
  attachment,
}: MarkdownAttachmentViewProps) {
  const isAttachmentProcessing = attachment.status === "processing";
  const shouldShowSkeleton = isAttachmentProcessing && !attachment.content;

  if (shouldShowSkeleton) {
    return (
      <div className="px-6 overflow-hidden">
        <TextFileSkeleton />
      </div>
    );
  }

  return (
    <div className="px-6">
      <Markdown
        syntaxHighlighterOptions={syntaxHighlighterOptions}
        isStreaming={isAttachmentProcessing}
        SkeletonComponent={TextFileSkeleton}
      >
        {attachment.content ?? ""}
      </Markdown>
    </div>
  );
}
